/**
 * LocalScreen - Location selection screen for mobile emulator
 */
import React from 'react';
import { MapPin, ChevronLeft, ChevronRight, RefreshCw } from 'lucide-react';
import type { Hospital } from '../../services/hospitalService';
import type { Location } from '../../services/mobileService';

interface LocalScreenProps {
  selectedHospital: Hospital | null;
  locais: Location[];
  loadingLocais: boolean;
  error: string;
  onBack: () => void;
  onSelectLocal: (local: Location) => void;
}

export const LocalScreen: React.FC<LocalScreenProps> = ({
  selectedHospital,
  locais,
  loadingLocais,
  error,
  onBack,
  onSelectLocal,
}) => {
  return (
    <div className="flex-1 overflow-y-auto p-6">
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
      >
        <ChevronLeft className="w-4 h-4" />
        Voltar
      </button>

      <div className="mb-6">
        <p className="text-sm text-gray-600 mb-1">{selectedHospital?.nome}</p>
        <h2 className="text-xl font-bold text-gray-900">Selecione o Local</h2>
      </div>

      {error && (
        <div className="bg-red-100 border-2 border-red-200 rounded-lg p-3 mb-4">
          <p className="text-red-800 text-sm font-medium">⚠️ {error}</p>
        </div>
      )}

      {loadingLocais ? (
        <div className="flex justify-center py-12">
          <RefreshCw className="w-8 h-8 text-purple-600 animate-spin" />
        </div>
      ) : (
        <div className="space-y-3">
          {locais.map((local) => (
            <button
              key={local.id}
              onClick={() => onSelectLocal(local)}
              className="w-full bg-white border-2 border-gray-200 hover:border-blue-500 rounded-lg p-4 transition-all"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-purple-600" />
                </div>
                <div className="flex-1 text-left">
                  <p className="font-bold text-gray-900 text-lg">{local.nome}</p>
                  {local.descricao && (
                    <p className="text-xs text-gray-500 mt-1">{local.descricao}</p>
                  )}
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
